import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLeadDialog } from '../context/LeadDialogContext';

const CTA = () => {
  const { open: openLead } = useLeadDialog();
  return (
    <section className="bg-neutral-950 text-white overflow-hidden relative">
      <div
        aria-hidden
        className="absolute inset-0 opacity-50"
        style={{
          background:
            'radial-gradient(50% 60% at 20% 30%, rgba(59,130,246,0.30), transparent), radial-gradient(50% 60% at 80% 70%, rgba(255,255,255,0.06), transparent)',
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-[44px] lg:text-[68px] leading-[1.02] tracking-[-0.025em] font-semibold">
            Make Enterprise AI <span className="italic font-light text-neutral-300">work.</span>
          </h2>
          <p className="mt-6 text-[17px] text-neutral-300 leading-relaxed">
            Join 85+ leading companies running on MetaxuOne. Try the platform free or join a live demo with our experts.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Button
              onClick={() => openLead({ source: 'cta-try-free', title: 'Try MetaxuOne for free', subtitle: 'Tell us a bit about you — we’ll set you up with a free trial and a personalized walkthrough.' })}
              className="h-12 px-7 rounded-full bg-white text-neutral-900 hover:bg-neutral-200 text-[14px] font-medium inline-flex items-center gap-2"
            >
              Try for free <ArrowRight className="w-4 h-4" />
            </Button>
            <Button
              onClick={() => openLead({ source: 'cta-join-demo', title: 'Join a live demo' })}
              variant="outline"
              className="h-12 px-7 rounded-full border-neutral-700 bg-transparent text-white hover:bg-neutral-900 text-[14px] font-medium"
            >
              Join a demo
            </Button>
          </div>
        </div>

        {/* Marquee */}
        <div className="mt-20 overflow-hidden">
          <div className="flex gap-10 whitespace-nowrap animate-[marquee_30s_linear_infinite] text-[28px] lg:text-[44px] font-semibold tracking-[-0.02em] text-neutral-800">
            {Array.from({ length: 8 }).map((_, i) => (
              <span key={i} className="inline-flex items-center gap-10">
                Get started
                <span className="w-2 h-2 rounded-full bg-blue-500" />
              </span>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
      `}</style>
    </section>
  );
};

export default CTA;
